<span
  class="catalog-authors"
  *ngIf="visibleAuthors.length"
  [pTooltip]="tooltipHtml"
  [escape]="false"
  tooltipPosition="top"
  tooltipStyleClass="catalog-authors-tooltip-panel"
  (click)="$event.stopPropagation()"
>
  <span
    class="author-chip"
    *ngFor="let author of visibleAuthors"
    [ngStyle]="chipStyle(author)"
  >{{ author.initials }}</span>
</span>
